import React from 'react';
import {inject, observer} from 'mobx-react';

import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from 'react-perfect-scrollbar'
import Wip from './wip.jsx';
import ChatBaseBalloon from 'System/components/chatbaseballoon';

import parse from 'html-react-parser';
import CookieConsent from "react-cookie-consent";

// Devextreme
import itMessages from "devextreme/localization/messages/it.json";
import frMessages from "devextreme/localization/messages/fr.json";
import deMessages from "devextreme/localization/messages/de.json";
import nlMessages from "devextreme/localization/messages/nl.json";
import esMessages from "devextreme/localization/messages/es.json";

import {locale, loadMessages} from 'devextreme/localization';

// Routers
import {RouterContent, RouterNavigation, RouterSidebar, RouterPopup} from '../components/router.jsx';

// Views
import Notifications from '../components/notifications.jsx';
import UserOptions from '../components/useroptions.jsx';
import Offline from '../components/offline.jsx';
import BottomBarMobile from '../components/bottombarmenu_mobile.jsx';
import PwaInstallBanner from '../components/PwaInstallBanner.jsx';
import BiometricLock from '../components/biometricLock.jsx';

const bannerStyle = (i) => ({
    top: `${1.5 + i * 1}rem`,
    right: `${1.5 + i * 1}rem`,
    zIndex: 1052 - i,
});

const Base = inject("rootstore", "langstore")(observer(
    class Base extends React.Component {

        constructor(props) {
            super(props);
            loadMessages(itMessages);
            loadMessages(frMessages);
            loadMessages(deMessages);
            loadMessages(nlMessages);
            loadMessages(esMessages);
        }

        render() {

            const props = this.props;
            const { rootstore, langstore } = props;
            locale(rootstore.language || navigator.language || navigator.browserLanguage);
            const scrollInfo = rootstore.uiScrollInfo > 1 ? 'active' : 'inactive';

            const routes = rootstore.routes;
            const {routeId} = rootstore.routeParamsCurrent;

            const {
                navigation,
                sidebar
            } = routes.find(r => routeId === r.id) || {};

            const {logoExpanded} = rootstore.config.paths;

            let uiSidebarExpanded = rootstore.uiSidebarExpanded;

            const biometricVisible = !!rootstore.userToken
                && !rootstore.userInfo.internal
                && rootstore.biometricSetupPending
                && rootstore.biometricAvailable
                && !rootstore.biometricEnabled;

            const pushVisible = !!rootstore.userToken
                && !rootstore.userInfo.internal
                && rootstore.userInfo.canReceivePushNotifications
                && rootstore.pushNotificationSetupPending
                && rootstore.pushNotificationSupported
                && !rootstore.pushNotificationSubscribed
                && rootstore.pushNotificationPermission !== 'denied';

            let bannerIdx = 0;
            const biometricBannerIdx = biometricVisible ? bannerIdx++ : -1;
            const pushBannerIdx     = pushVisible      ? bannerIdx++ : -1;
            const pwaBannerOffset   = bannerIdx;

            if (rootstore.config.wip === true) {
                return (
                    <Wip/>
                )
            } else {

                return (
                    <div className={"ts_base " + rootstore.bodyClassCurrent}>
                        <RouterPopup/>
                        {rootstore.biometricRelockActive && (
                            <div className="ts_modal_wrap">
                                <div className="ts_modal_back" />
                                <div className="ts_modal_frame">
                                    <BiometricLock
                                        onRetry={() => rootstore.biometricRelockRetry()}
                                        onBypass={() => rootstore.biometricBypass()}
                                        loading={rootstore.biometricRefreshPending}
                                    />
                                </div>
                            </div>
                        )}
                        <Offline/>
                        <div className="row no-gutters ts_content_row">
                            {sidebar &&
                            <aside
                                className={rootstore.uiSidebarExpanded === true ? "ts_sidebar col-md-3 col-12 ts_sidebar_expanded" : "ts_sidebar col ts_sidebar_minimized"}>
                                <div className="ts_sidebar_header">
                                    <img
                                        onClick={() => rootstore.routeChange(rootstore.config.routes.index)}
                                        src={logoExpanded}
                                        className={"d-md-block"}
                                        alt="Company Logo"
                                    />
                                </div>
                                <div className="ts_sidebar_body">
                                    <PerfectScrollbar
                                        options={{ suppressScrollX: true }}>
                                        <RouterSidebar/>
                                    </PerfectScrollbar>
                                </div>
                                <nav className="ts_sidebar_menu fixed_sidebar_menu">
                                    <div className="ts_sidebar_item">
                                        <div className="ts_sidebar_item_inner">
                                            <div
                                                className="ts_sidebar_item_title ts_sidebar_toggle"
                                                onClick={() => rootstore.uiSidebarToggle()}>
                                                <i className="fa fa-chevron-left icon_m"/>
                                                {(uiSidebarExpanded) ?
                                                    <span
                                                        className="ts_text2 ts_sidebar_item_label">{langstore.t("ui_minimize_sidebar", "Minimizza")}</span>
                                                    :
                                                    <span
                                                        className="ts_text2 ts_sidebar_item_label">{langstore.t("ui_fixed_sidebar", "Blocca")}</span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </nav>

                            </aside>
                            }
                            <section className="ts_body col-12 col-md">
                                {navigation &&
                                    <div className={"row no-gutters ts_content_header " + scrollInfo}>
                                        <div className="col-4 d-none d-lg-flex align-items-center">
                                            <RouterNavigation/>
                                        </div>
                                        <div className="col mr2">
                                            <UserOptions/>
                                        </div>
                                    </div>
                                }
                                <div className={`ts_content_body ${navigation ? "" : "_disable-navigation"}`}>
                                    {biometricVisible && (
                                        <div className="pwa_banner pwa_banner--stacked" style={bannerStyle(biometricBannerIdx)} role="alert">
                                            <button
                                                className="pwa_banner__btn-never"
                                                onClick={() => rootstore.biometricTemporaryDisabled()}
                                                title={langstore.t("biometric_setup_no", "Non ora")}
                                            >
                                                <i className="fas fa-times" />
                                            </button>
                                            <div className="pwa_banner__icon">
                                                <i className="fas fa-fingerprint" />
                                            </div>
                                            <div className="pwa_banner__body">
                                                <p className="pwa_banner__title">
                                                    {langstore.t("biometric_setup_offer_title", "Accedi velocemente")}
                                                </p>
                                                <p className="pwa_banner__subtitle">
                                                  {langstore.t("biometric_setup_offer_subtitle", "Vuoi abilitare l'accesso biometrico per le prossime sessioni?")}
                                                </p>
                                            </div>
                                            <div className="pwa_banner__actions">
                                                <button
                                                    className="ts_button2 pwa_banner__btn-install"
                                                    onClick={() => rootstore.biometricRegister()}
                                                >
                                                    {langstore.t("biometric_setup_yes", "Attiva")}
                                                </button>
                                                <button
                                                    className="btn pwa_banner__btn-later"
                                                    onClick={() => rootstore.biometricNeverAsk()}
                                                >
                                                    {langstore.t("biometric_setup_never", "Non chiedermelo più")}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    {pushVisible && (
                                        <div className="pwa_banner pwa_banner--stacked" style={bannerStyle(pushBannerIdx)} role="alert">
                                            <button
                                                className="pwa_banner__btn-never"
                                                onClick={() => rootstore.pushNotificationBannerDismiss()}
                                                title={langstore.t("push_setup_not_now", "Non ora")}
                                            >
                                                <i className="fas fa-times" />
                                            </button>
                                            <div className="pwa_banner__icon">
                                                <i className="fas fa-bell" />
                                            </div>
                                            <div className="pwa_banner__body">
                                              <p className="pwa_banner__title">
                                                {langstore.t("push_setup_offer_title", "Resta aggiornato")}
                                              </p>
                                              <p className="pwa_banner__subtitle">
                                                {langstore.t("push_setup_offer_subtitle", "Vuoi abilitare le notifiche su questo dispositivo?")}
                                              </p>
                                            </div>
                                            <div className="pwa_banner__actions">
                                                <button
                                                    className="ts_button2 pwa_banner__btn-install"
                                                    onClick={() => {
                                                        rootstore.pushNotificationBannerDismiss();
                                                        rootstore.pushNotificationSubscribe();
                                                    }}
                                                >
                                                    {langstore.t("push_setup_activate", "Attiva")}
                                                </button>
                                                <button
                                                    className="btn pwa_banner__btn-later"
                                                    onClick={() => rootstore.pushNotificationBannerNeverAsk()}
                                                >
                                                    {langstore.t("push_setup_never", "Non chiedermelo più")}
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    <RouterContent/>
                                    <Notifications/>
                                    {rootstore.userToken &&
                                        <BottomBarMobile/>
                                    }
                                </div>
                            </section>
                        </div>
                        {navigation &&
                            <div className="base-overlay" onClick={() => rootstore.uiSidebarToggle()}/>
                        }

                        <CookieConsent
                          containerClasses="cookie-consent-banner-wrapper"
                          buttonClasses="cookie-consent-banner-button"
                          buttonText={langstore.t('lbl_understand', 'Ho capito')}
                          cookieName="CustomerHubCookie"
                          expires={90}
                        >
                          {parse(langstore.t('cookie_consent_default_msg', 'Utilizziamo cookie di Google Analytics anonimizzati e cookie tecnici per migliorare l\'esperienza utente.'))}
                        </CookieConsent>

                        {rootstore.config?.chatbase?.enabled &&
                          <ChatBaseBalloon/>
                        }

                        <PwaInstallBanner offset={pwaBannerOffset}/>

                    </div>
                )
            }
        }
    }
));

export default Base;
